import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {OperativesService} from '../../../operatives/services/operatives.service';
import {ListDataService} from '../../../services/list-data.service';
import {IRiskInfo} from '../../../message-models/risk-info.interface';
import {IJobLevelInfo} from '../../../message-models/job-level.interface';
import {IRiskMatrixEntry} from '../../../message-models/risk-matrix-entry.interface';
import {OperativeInfo} from '../../../domain-model/operative-info.class';
import {IBreadcrumb} from '../../../eca-breadcrumb/models/breadcrumb.interface';
import {EcaBreadcrumbService} from '../../../eca-breadcrumb/services/eca-breadcrumb.service';
import {RiskHelpModalService} from '../../../services/risk-help-modal.service';
import {IJobTitleInfo} from '../../../message-models/job-title.interface';
import {OurUserService} from '../../../users/services/user.service';
import {IUserInfo} from '../../../users/models/userInfo.interface';
import {consts} from '../../../common/modals/consts';
import {BehaviorSubject, Subscription} from 'rxjs';
import {EcaConfirmProcessService} from '../../../shared/services/eca-confirm-process.service';
import {AlertsService} from '../../../alerts/services/alerts.service';
import {HelpModalService} from '../../../help/services/help-modal.service';
import {HelpConsts} from '../../../help/models/help-consts';
import {IEmploymentStatus} from '../../../message-models/employment-status.interface';
import { IOperativeTypeInfo } from '../../../message-models/operative-type.interface';
import { IBusinessUnitInfo } from '../../../message-models/business-unit.interface';
import { ICompanyJobTitle } from '../../../message-models/company-job-title.interface';
import { CompanyJobRoleService } from '../../../setting/job-role/services/company-job-role.service';

@Component({
  selector: 'app-company-operatives',
  templateUrl: './company-operatives.component.html',
  styleUrls: ['./company-operatives.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CompanyOperativesComponent implements OnInit, OnDestroy {
  allRisks: IRiskInfo[] = [];
  allRisksLoaded = false;

  allJobLevels: IJobLevelInfo[] = [];
  allJobLevelsLoaded = false;

  allJobTitles: IJobTitleInfo[] = [];
  allJobTitlesLoaded = false;
  allCompanyJobTitles: ICompanyJobTitle[] = [];


  allEmploymentStatuses: IEmploymentStatus[] = [];
  allEmploymentStatusesLoaded = false;

  allOperativeTypes: IOperativeTypeInfo[] = [];
  allOperativeTypesLoaded = false;

  allBusinessUnits: IBusinessUnitInfo[] = [];
  allBusinessUnitsLoaded = false;

  riskMatrix: IRiskMatrixEntry[] = [];
  riskMatrixLoaded = false;

  operatives: OperativeInfo[] = [];
  companyId: string = consts.emptyGuid;
  operativesAsOf = '';
  loadingOperatives = true;
  public loggedInUser: IUserInfo;
  private loggedInUserSubscription: Subscription;
  loadedOperativesSubject = new BehaviorSubject<boolean>(false);

  constructor(private operativesService: OperativesService,
              private ecaBreadcrumbService: EcaBreadcrumbService,
              private alertsService: AlertsService,
              private listDataService: ListDataService,
              private riskHelpModalService: RiskHelpModalService,
              private helpService: HelpModalService,
              private userService: OurUserService,
              private companyJobRoleService: CompanyJobRoleService,
              private confirmProcessService: EcaConfirmProcessService, ) { }

  ngOnInit(): void {
    this.userService.getLoggedInUser().subscribe(user => {
      this.loggedInUserSubscription = this.userService.getLoggedInUserSubject().subscribe( user => {
        this.updateUserAndReload(user);
      });
    });


    this.listDataService.getAllRisks().subscribe( {
      next: response => {
        this.allRisks = response;
        this.allRisksLoaded = true;
        this.operativesService.setOperativeRisks(response);
      }
    });

    this.listDataService.getAllJobTitles().subscribe( {
      next: response => {
        this.allJobTitles = response;
        this.allJobTitlesLoaded = true;
      }
    });

    this.companyJobRoleService.getCompanyJobTitlesByCompanyId(this.companyId).subscribe({
      next: response => {
        this.allCompanyJobTitles = response;
        this.allJobTitlesLoaded = true;
      }
    });





    this.listDataService.getAllOperativeTypes().subscribe({
      next: response => {
        this.allOperativeTypes = response;
        this.allOperativeTypesLoaded = true;
      }
    });

    this.listDataService.getBusinessUnitsForCompany(this.companyId).subscribe({
      next: response => {
        this.allBusinessUnits = response;
        this.allBusinessUnitsLoaded = true;
      }
    });

    this.listDataService.getAllJobLevels().subscribe( {
      next: response => {
        this.allJobLevels = response;
        this.allJobLevelsLoaded = true;
        this.operativesService.setOperativeJobLevels(response);
      }
    });

    this.listDataService.getRiskMatrix().subscribe( {
      next: response => {
        this.riskMatrix = response;
        this.riskMatrixLoaded = true;
        this.operativesService.setOperativeRiskMatrixLevels(response);
      }
    });
    this.listDataService.getAllEmploymentStatuses().subscribe( {
      next: response => {
        this.allEmploymentStatuses = response;
        this.allEmploymentStatusesLoaded = true;
        this.operativesService.setOperativeEmploymentStatus(response);
      }
    });
  }

  private updateUserAndReload(user: IUserInfo) {
    this.loggedInUser = user;
    this.companyId = this.loggedInUser?.companyId;
    if (this.companyId !== consts.emptyGuid && this.companyId !== undefined) {
      this.loadOperatives(new Date().toISOString());
    }
    this.populateBreadcrumbs();
  }

  ngOnDestroy() {
    this.loggedInUserSubscription.unsubscribe();
  }

  private loadOperatives(asOf: string,allHistory: boolean = false) {
    this.operativesService.getOperativesInCompany(this.companyId, asOf,false,allHistory).subscribe({
      next: operatives => {
        this.operatives = new Array<OperativeInfo>();
        this.operatives = operatives;
    
        this.loadedOperativesSubject.next(true);
        this.operatives?.forEach(op => {
          if (op.currentOperativeTypeId == "4eff2451-6793-4590-82c1-fc189dc47859") {
            op.jobTitle = this.allCompanyJobTitles.find(x => x.id === op.currentJobTitleId)?.name;
          }
          else {
            op.jobTitle = this.allJobTitles?.find(x => x.id === op.currentJobTitleId)?.name;
          }
          
          op.operativeType = this.allOperativeTypes?.find(x => x.id === op.currentOperativeTypeId)?.name;
          op.businessUnit = this.allBusinessUnits?.find(x => x.id === op.currentBusinessUnitId)?.name;
          op.totalCPDHours = op.trainingRecords.filter(record => record.cpdHour > 0).reduce((acc, record) => acc + record.cpdHour, 0);
          op.totalCPDHours = parseFloat(op.totalCPDHours.toFixed(2));
        });

        this.operativesService.setOperativeRiskAndLevels(this.allRisks, this.allJobLevels, this.riskMatrix, this.allEmploymentStatuses);
      }, error: err => {
        this.loadingOperatives = false;
      }, complete: () => {
        this.loadingOperatives = false;
      }
    });
  }

  private populateBreadcrumbs() {
    const operativeBreadCrumbs = new Array<IBreadcrumb>();
    operativeBreadCrumbs.push({label: this.loggedInUser?.companyName?.toString() + ' - ' +  'Operatives', iconName: 'users'} as IBreadcrumb);
    this.ecaBreadcrumbService.breadCrumbs.next(operativeBreadCrumbs);
  }

  openRiskHelp() {
    this.riskHelpModalService.openRiskHelpModal('Help', this.riskMatrix, this.allRisks, this.allJobLevels, this.operatives, null, this.operativesAsOf, this.loggedInUser?.companyName, false);
  }

  reloadOperatives(asOf: string,allHistory:boolean = false) {
    this.loadingOperatives = true;
    this.loadOperatives(asOf,allHistory);
    this.loadingOperatives = false;
    this.alertsService.getSupervisionAlertsCountForCompany(this.loggedInUser?.companyId).subscribe();
  }

  asOfSelected(date: any) {
    this.operativesAsOf = date;
  }

  openOperativesHelp() {
    this.helpService.openHelpModal(HelpConsts.CompanyOperativesHelp);
  }
}
